<template>
  <div class="transaction-list-widget" :style="style">
    <div class="widget-wrapper">
      <div class="list">
        <div v-for="transaction in relevantTransactions" v-bind:key="transaction">
          <span>🔍</span>
          <span class="billing-amount">{{ formatAmount(transaction.billingAmount) }} ₪</span>
          <span>{{ transaction.businessName }}</span>
        </div>
      </div>
      <div class="separator"/>
      <div class="footer">
        <div v-if="areMultiplePages" class="page-number">{{widget.pageNumber}}/{{widget.numPages}}</div>
        <div v-else></div>
        <div v-if="isLastPage">
          <span>👈</span>
          <span class="sum">{{ formatAmount(lastMonthSum) }} ₪</span>
          <span>סה״כ</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TransactionListWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    areMultiplePages() {
      return this.insuranceTransactions.length > this.widget.numTransactionsInPage;
    },
    isLastPage() {
      return this.endIndex === this.insuranceTransactions.length
        || this.widget.pageNumber === this.widget.numPages;
    },
    startIndex() {
      return this.widget.numTransactionsInPage * (this.widget.pageNumber - 1);
    },
    endIndex() {
      return this.startIndex + this.widget.numTransactionsInPage < this.insuranceTransactions.length
        ? this.startIndex + this.widget.numTransactionsInPage : this.insuranceTransactions.length;
    },
    relevantTransactions() {
      return _.slice(this.insuranceTransactions, this.startIndex, this.endIndex);
    },
    lastMonthSum() {
      return this.widget.transactionsSum;
    },
    insuranceTransactions() {
      return _.chain(this.widget.transactions)
        .sortBy(transaction => transaction.billingAmount)
        .reverse()
        .value();
    },
    style() {
      return {
        top: `${this.widget.top}px`,
        zIndex: this.widget.zIndex,
      };
    },
  },
  methods: {
    formatAmount(value) {
      const amount = Math.abs(Number(value));
      const result = amount.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });
      return result.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
.transaction-list-widget {
  position: absolute;
  display: flex;
  width: 430px;
  left: 0;
  .widget-wrapper {
    text-align: right;
    direction: rtl;
    border-radius: 14px;
    line-height: 22px;
    background-color: $riseup_white;
    width: 100%;
    margin-right: 30px;
    margin-left: 30px;
    font-size: 16px;
    font-family: SimplerPro;
    .list {
      padding: 22px 24px 9px;
      line-height: 30px;
      .billing-amount {
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }
  .separator {
    height: 1px;
    width: 100%;
    background: $riseup_gray_0;
  }
  .footer {
    padding: 9px 24px;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;

    .sum {
      font-weight: bold;
      margin-right: 5px;
    }

    .page-number {
      color: #B44399;
      font-size: 10px;
    }
  }
}
</style>
